import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormBuilderFielditemComponent } from '../../../../../../../shared/components/form-builder-fielditem/form-builder-fielditem.component';
import { BuyerInfoStep } from '../../../../../../../shared/product/buyerInfoStep';

@Component({
  selector: 'app-subscription-step-three',
  templateUrl: './subscription-step-three.component.html',
  styleUrls: ['./subscription-step-three.component.scss']
})
export class SubscriptionStepThreeComponent extends BuyerInfoStep implements OnInit, AfterViewInit {
  stepForm!: FormGroup;
  @Input() productObject: any;
  @ViewChild(FormBuilderFielditemComponent) FormBuilder!: FormBuilderFielditemComponent;

  constructor(public fb: FormBuilder) {
    super(fb);
  }

  ngAfterViewInit() {
    if (this.productObject) {
      this.populateBuyerInfoFields(this.productObject);
    }
  }
}
